import React, { useEffect, useRef, useState } from "react";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import * as XLSX from "xlsx";
import {
  Form,
  Table,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
  InputGroup,
  Accordion,
  Toast,
} from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import {
  IconUserShare,
  IconUserOff,
  IconTrash,
  IconCircle,
  IconEdit,
  IconCopy,
  IconExchange,
  IconMailSpark,
  IconMailForward,
  IconUsers,
  IconBuildings,
  IconFileTypePdf,
  IconHistory,
  IconProgressCheck,
  IconHistoryToggle,
  IconFileTypeXls,
  IconPaperclip,
  IconFileSearch,
  IconBox,
  IconMessageCircle,
  IconUserPin,
  IconAddressBook,
  IconMessage,
  IconTriangle,
  IconRotateClockwise,
  IconBackspace,
  IconSearch,
  IconCalendarWeek,
  IconEye,
  IconLayoutGridFilled,
  IconLayoutListFilled,
} from "@tabler/icons-react";
import DynamicPagination from "../../components/DynamicPagination ";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { getAbbreviation } from "../../utils/_helpers";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import ConfirmationModal from "../../components/ConfirmationModal";
import userp from "../../assets/user_avtar.svg";
// import ActivateUser from "./ActivateUser";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/_helpers";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import SKU_Version_POPUP from "./Modals/SKU_Version_POPUP";
// import GetRFQHistoryPOP_UP from "./GetRFQHistoryPOP_UP";
import ExcelDialog from "./Modals/ExcelDialog";
import PdfDocument from "./PDF/main";
// import KOorCustomerEmailDialog from "./Email/KOorCustomerEmailDialog";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
// import EmailQuoteDialog from "./Email/EmailQuoteDialog";

// import CopyEmailDialog from "./CopyEmailDialog.js/CopyEmailDialog";
import Lottie from "lottie-react";
import WinData from "../../assets/won-status.json";
import View_ProjectDetails from "./ViewDetail/View_ProjectDetails";
import EmailHistory from "./Email/EmailHistory";
import EmailProjectDialog from "./Email/EmailProjectDialog";
import PriceChangesModal from "./PriceChange/PriceChangesModal";
import useIdleLogout from "../../hooks/useIdleLogout";
import ProjectTableListing from "./ProjectTableListing";

const ProjectListing = () => {
  const [page, setPage] = useState({
    active: 1,
    draft: 1,
    completed: 1,
    pending: 1,
  });
  const [limit, setLimit] = useState(10);
  const [rfqSku, setRfqSku] = useState("");
  const [hasMoreActive, setHasMoreActive] = useState(true);
  const [hasMoreDraft, setHasMoreDraft] = useState(true);
  const [hasMorePending, setHasMorePending] = useState(true);
  const [hasMoreCompleted, setHasMoreCompleted] = useState(true);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [isListView, setIsListView] = useState(false);
  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    rfq_id: "",
    btnText: "",
    label: "",
  });

  const statusOptions = [
    { label: "Draft", value: "DRAFT" },
    { label: "Pending", value: "PENDING" },
    { label: "Active", value: "ACTIVE" },
    { label: "Completed", value: "COMPLETED" },
  ];

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
  });
  const [isHistoryOpen, setIsHistoryOpen] = useState({
    show: false,
  });

  const [isExcelOpen, setIsExcelOpen] = useState({
    show: false,
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });

  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    rfq_id: "",
  });

  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    products: [],
    isStatusUpdate: false,
  });

  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    rfq_id: "",
  });

  // const [searchDebounce, setSearchDebounce] = useState({
  //   searchInvoice: "",
  //   searchOpportunityName: "",
  // });

  const triggerCardHighlight = (rfq_id) => {
    setHighlightedOrders((prev) => [...prev, rfq_id]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== rfq_id));
    }, 3000);
  };

  const handleSKUVERSION_OPEN = (e, rfq) => {
    e.preventDefault();
    setRfqSku(rfq);
    setIsModalOpen({ show: true });
  };
  const handleHistoryOpen = (e, rfq) => {
    e.preventDefault();
    setRfqSku(rfq);
    setIsHistoryOpen({ show: true });
  };

  const [isKOorCustomerDialogOpen, setIsKOorCustomerDialogOpen] =
    React.useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [contractFilter, setContractFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true); // runs once on mount

  const [activeData, setActiveData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [activeStatuses, setActiveStatuses] = useState([]);

  const [show, setShow] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);

  const StatusList = ["Pending", "Active", "Completed", "Draft"];

  const handleTabClick = (step) => {
    setCurrentStep(step);
  };

  useEffect(() => {
    setExcelData([
      ...activeData,
      ...draftData,
      ...pendingData,
      ...completedData,
    ]);
  }, [activeData, draftData, pendingData, completedData]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = useSelector((state) => state.auth.user);

  const [isPriceOpen, setIsPriceOpen] = useState({
    show: false,
    onSuccessFetch: false,
  });

  const location = useLocation();

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const viewOpportunityId = params.get("viewOpportunityId");

  //   if (viewOpportunityId) {
  //     const allOpportunities = [
  //       ...draftData,
  //       ...pendingData,
  //       ...cancelledData,
  //       ...wonData,
  //       ...lostData,
  //     ];

  //     const matchedOrder = allOpportunities.find(
  //       (opportunity) => String(opportunity.rfq_id) === viewOpportunityId
  //     );

  //     if (matchedOrder) {
  //       setIsViewOpen({
  //         show: true,
  //         products: matchedOrder,
  //         isStatusUpdate: false,
  //       });
  //     }
  //   }
  // }, [
  //   location.search,
  //   draftData,
  //   pendingData,
  //   cancelledData,
  //   wonData,
  //   lostData,
  // ]);

  // check perminssion
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const userAssignRole = user?.permissions?.manage_role || [];
  const canDeleteUser = hasPermission(userAssignRole, "delete");
  const canAssignRole = hasPermission(userAssignRole, "write");
  // check perminssion

  // const { postData: fetchOpportunity, data } = usePostRequest(
  //   API_ENDPOINTS.LISTING_OPPORTUNITIES
  // );

  const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
    API_ENDPOINTS.DownLoadFile,
  );

  const {
    data: activeres,
    loadingActive,
    postData: fetchOpportunityActive,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: completedres,
    loadingCompleted,
    postData: fetchOpportunityCompleted,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: draftres,
    loadingDraft,
    postData: fetchOpportunityDraft,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: penddingres,
    loadingPending,
    postData: fetchOpportunityPending,
  } = usePostRequest(API_ENDPOINTS.LISTING_PROJECT);
  const {
    data: contractData,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS,
  );

  const handleGenerateExcel = (selectedFields) => {
    try {
      if (!excelData || excelData?.length === 0) {
        throw new Error("No data available to export");
      }
      if (!selectedFields || selectedFields.length === 0) {
        throw new Error("No fields selected for export");
      }

      const formattedData = excelData?.map((row, index) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Project Name":
              filteredRow[field] = row?.opportunity_name || "";
              break;
            case "Project No":
              filteredRow[field] = row.rfq_id || "";
              break;
            case "Contract Vehicle":
              filteredRow[field] = row.ContractType.name || "";
              break;
            case "KO name":
              filteredRow[field] = row.rfqKo.name || "";
              break;
            case "KO email":
              filteredRow[field] = row.rfqKo.email || "";
              break;
            case "KO phone":
              filteredRow[field] = row.rfqKo.phone || "";
              break;
            case "KO address":
              filteredRow[field] = row.rfqKo.address || "";
              break;
            case "Published Date":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Due Date":
              filteredRow[field] = row.due_date
                ? moment(row.due_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Project Description":
              filteredRow[field] = row.brief;
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;

            //   "POC Name",
            //     "POC Email",
            //     "POC Phone",

            case "POC Name":
              filteredRow[field] = row.rfqShipping.name;
              break;
            case "Customer Name":
              filteredRow[field] = row.rfqShipping.name;
              break;
            case "Customer Email":
              filteredRow[field] = row.rfqShipping.email;
              break;
            case "Customer Phone":
              filteredRow[field] = row.rfqShipping.phone;
              break;
            case "Customer Address":
              filteredRow[field] = row.rfqShipping.address;
              break;
            case "Shipping Method":
              filteredRow[field] = row.shipping_method;
              break;
            case "Sales Head Name":
              filteredRow[field] = row.sales_lead_name;
              break;
            case "Sales Head Email":
              filteredRow[field] = row.sales_lead_email;
              break;
            case "Sales Head Ph":
              filteredRow[field] = row.sales_lead_phone;
              break;
            case "Shipping Terms":
              filteredRow[field] = row.shipping_term ? row.shipping_term : "";
              break;
            case "Estimated Delivery":
              filteredRow[field] = row.estimated_delivery;
              break;
            case "Payment Terms":
              const selectedTerm = TERMS.Term.find(
                (term) => term.Id === row.payment_term,
              );
              if (selectedTerm) {
                filteredRow[field] = selectedTerm.Name;
              }
              break;
            case "Other Cost": {
              if (row.other_cost_json) {
                try {
                  const otherCosts = Array.isArray(row.other_cost_json)
                    ? row.other_cost_json
                    : JSON.parse(row.other_cost_json);

                  otherCosts.forEach((cost, idx) => {
                    if (cost.Name || cost.Amount) {
                      // Only add if either Name or Amount exists
                      if (cost.Name) {
                        filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
                      }
                      if (cost.Amount) {
                        filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
                      }
                    }
                  });
                } catch (e) {
                  console.error("Error parsing other_cost_json:", e);
                }
              }
              break;
            }
            case "Shipping Cost($)":
              filteredRow[field] = row.shipping_cost;
              break;
            case "Tax($)":
              filteredRow[field] = row.tax;
              break;
            case "Total Cost($)":
              filteredRow[field] = row.total_cost_before_margin;
              break;
            case "Total Price($)":
              filteredRow[field] = row.total_cost_after_margin;
              break;
            case "Created Date":
              filteredRow[field] = row.created_at
                ? moment(row.created_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Status":
              filteredRow[field] = row.status;
              break;
            default:
              filteredRow[field] = "";
              break;
          }
        });
        return filteredRow;
      });

      if (formattedData.length === 0) {
        throw new Error("No valid data to export");
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);

      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      const today = new Date(); // Get current date
      const excelFileName =
        "ASPETTO SALES-" +
        String(today).split("T")[0] +
        "(" +
        "STATUS:" +
        "" +
        ")" +
        ".xlsx"; // Generate file name
      XLSX.writeFile(wb, excelFileName); // Write Excel file to disk
      console.log("Excel file generated successfully");
    } catch (error) {
      console.error("Error generating Excel file:", error.message);
      alert(error.message); // Display error to the user
    }
  };

  const stickyRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);
  useIdleLogout();

  useEffect(() => {
    const handleScroll = () => {
      if (stickyRef.current) {
        const offsetTop = stickyRef.current.offsetTop;
        setIsFixed(window.scrollY > offsetTop);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async (row) => {
    console.log("row", row);

    const OP_arr = String(`project`).split(".");
    for (var i = 0; i < OP_arr.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }

    const updatedInvoiceData = {
      // ...InvoiceData,
      invoice_num: String(row.rfq_id),
      Contract_Vehicle: row.ContractType.name,
      KO_name: row.rfqKo.name, //formatStringKey
      KO_email: row.rfqKo.email,
      KO_phone: row.rfqKo.phone,
      KO_address: row.rfqKo.address,
      Print_Date: String(today),
      trans_date: String(row.updated_at).split("T")[0],
      due_date: row.due_date,
      Valid_For: row.valid_for,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: row.RfqProducts,
      Tax: row.tax,
      Shipping_Cost: row.shipping_cost,
      Total_Cost: row.total_cost_after_margin,
      Other_Cost: row.other_cost_json,
      BillTo_Phone: row.rfqBilling.phone,
      BillTo_Name: row.rfqBilling.name,
      BillTo_Address: row.rfqBilling.address,
      BillTo_Email: row.rfqBilling.email,
      Notes: row.RfqNotes,
      Shipping_Details: {
        Organization_Name: row.organization_name,
        KO_name: row.rfqKo.name,
        Sales_Head_Info: {
          Name: row.sales_lead_name, //formatStringKey
          Email: row.sales_lead_email,
          Phone: row.sales_lead_phone,
        },
        Customer_Name: row.rfqShipping.name, // formatStringKey
        Customer_Email: row.rfqShipping.email,
        Customer_Phone: row.rfqShipping.phone,
        Customer_Address: row.rfqShipping.address,
        Shipping_Method: row.shipping_method,
        Shipping_Method_Detail: row.shipping_method_detail,
        Shipping_Terms: row.shipping_term,
        Estimated_Delivery: row.estimated_delivery,
        Payment_Terms: row.payment_term,
        Payment_Terms_Details: row.payment_term_detail,
      },
    };

    // setInvoiceData(updatedInvoiceData);
    //  Format Opportunity Name for file name
    let File_Opportunity_Name = "";

    File_Opportunity_Name = OP_arr.join(" ");

    setTimeout(async () => {
      // setLoading(true);
      const pdfBlob = await pdf(
        <PdfDocument invoicedata={updatedInvoiceData} />,
      ).toBlob();

      const url = URL.createObjectURL(pdfBlob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${File_Opportunity_Name} ${String(row.invoice_no).split(".")[0]
        }.pdf`;
      document.body.appendChild(a);
      console.log("2", a.download);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };

  const searchInputRef = useRef();

  // const handleSearch = () => {
  //   const searchValue = searchInputRef.current.value?.trim();

  //   setPage(() => ({
  //     draft: 1,
  //     won: 1,
  //     lost: 1,
  //     cancelled: 1,
  //     pending: 1,
  //   }));

  //   const isAnyFilterActive =
  //     searchValue.length > 0 ||
  //     salesHeadFilter !== "" ||
  //     contractFilter !== "" ||
  //     startDate !== null ||
  //     endDate !== null;

  //   if (!isAnyFilterActive) {
  //     toast.warning(
  //       "Please select at least one search filter or input before proceeding."
  //     );
  //     return;
  //   }

  //   setSearch(searchValue);
  //   setIsSearchClicked(true);
  //   setPage((prev) => ({ ...prev, won: 1 }));
  // };

  const handleSearch = () => {
    setActiveStatuses([]);
    const searchValue = searchInputRef.current.value?.trim();
    // Check if only one of the dates is selected
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }

    // const isAnyFilterActive =
    //   searchValue.length > 0 ||
    //   salesHeadFilter !== "" ||
    //   contractFilter !== "" ||
    //   selectedStatus.length > 0 ||
    //   (startDate !== null && endDate !== null);

    // if (!isAnyFilterActive) {
    //   toast.warning(
    //     "Please select at least one search filter or input before proceeding."
    //   );
    //   return;
    // }

    // Reset pages for all statuses
    setPage(() => ({
      draft: 1,
      active: 1,
      completed: 1,
      pending: 1,
    }));

    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  const handleContractFilter = (e) => {
    setContractFilter(e.target.value);
    setPage((prev) => ({ ...prev, active: 1 }));
  };

  const handlesalesHeadFilter = (e) => {
    setSalesHeadFilter(e.target.value);
    setPage((prev) => ({ ...prev, active: 1 }));
  };

  // const handleSelectStatus = (e) => {
  //   const selectedOptions = Array.from(
  //     e.target.selectedOptions,
  //     (option) => option.value
  //   );

  //   setSelectedStatus((prevStatus) => {
  //     return [...new Set([...prevStatus, ...selectedOptions])];
  //   });

  //   console.log("Selected statuses are", selectedStatus);
  // };

  // useEffect(() => {
  //   console.log("The values are ", selectedStatus);
  // }, [selectedStatus]);

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleClearFilter = (e) => {
    setSalesHeadFilter("");
    setContractFilter("");
    setStatusFilter("");
    setSelectedStatus([]);
    setSearch("");
    setStartDate(null);
    setEndDate(null);

    setPage(() => ({
      draft: 1,
      active: 1,
      completed: 1,
      pending: 1,
    }));

    // Trigger dependency so the original data is fetched again
    setIsInitialLoad(true);
    setIsSearchClicked(true);
  };

  // const handleOpenKOorCustomerEmailOpenDialog = (e) => {
  //   e.preventDefault();
  //   setIsEmaillOpen({ show: true });
  // };

  const onSuccessfulFetchOpportunityActive = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreActive(false);
    }

    setActiveData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityDraft = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreDraft(false);
    }
    setDraftData((prevData) => {
      // const combined = [...prevData, ...response?.data];
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };
  const onSuccessfulFetchOpportunityPending = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMorePending(false);
    }

    setPendingData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityCompleted = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreCompleted(false);
    }

    setCompletedData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const fetchData = async () => {
    await fetchRfq({ module_type: "RFQ" });
    await fetchContract();
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const isPagination = page.active > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("ACTIVE")));
    if (!shouldFetch) return;
    setHasMoreActive(true); // Reset hasMore on filter/search change

    fetchOpportunityActive(
      {
        page: page.active,
        project_type: "PROJECT",
        limit,
        status: "ACTIVE",
        sales_lead_email: salesHeadFilter || undefined,
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) =>
        onSuccessfulFetchOpportunityActive(response, page.active === 1),
      setActiveStatuses((prev) =>
        prev.includes("ACTIVE") ? prev : [...prev, "ACTIVE"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.active, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.draft > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("DRAFT")));
    if (!shouldFetch) return;

    setHasMoreDraft(true); // Correct: this is for DRAFT data

    fetchOpportunityDraft(
      {
        page: page.draft,
        limit,
        project_type: "PROJECT",
        status: "DRAFT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) =>
        onSuccessfulFetchOpportunityDraft(response, page.draft === 1),
      setActiveStatuses((prev) =>
        prev.includes("DRAFT") ? prev : [...prev, "DRAFT"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.draft, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.pending > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("PENDING")));
    if (!shouldFetch) return;
    setHasMorePending(true); // Reset hasMore on new search/filter

    fetchOpportunityPending(
      {
        page: page.pending,
        limit,
        status: "PENDING",
        project_type: "PROJECT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) =>
        onSuccessfulFetchOpportunityPending(response, page.pending === 1),
      setActiveStatuses((prev) =>
        prev.includes("PENDING") ? prev : [...prev, "PENDING"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.pending, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.completed > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("COMPLETED")));
    if (!shouldFetch) return;
    setHasMoreCompleted(true);

    fetchOpportunityCompleted(
      {
        page: page.completed,
        limit,
        status: "COMPLETED",
        project_type: "PROJECT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
      },
      (response) =>
        onSuccessfulFetchOpportunityCompleted(response, page.completed === 1),
      setActiveStatuses((prev) =>
        prev.includes("COMPLETED") ? prev : [...prev, "COMPLETED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.completed, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  const handleCopy_Quote = (selectedOption, rfq_id) => {
    navigate("/copy-quote", {
      state: {
        selectedCopy: selectedOption,
        rfqCopy: rfq_id,
      },
    });
  };

  const handleLoadMore = () => {
    if (hasMoreActive) {
      setPage((prev) => ({
        ...prev,
        active: prev.active + 1,
      }));
    }
  };

  // const handleLoadMoreDraft = () => {
  //   if (hasMoreDraft) {
  //     setPage((prev) => prev + 1);
  //   }
  // };
  const handleLoadMoreDraft = () => {
    if (hasMoreDraft) {
      setPage((prev) => ({
        ...prev,
        draft: prev.draft + 1,
      }));
    }
  };

  const handleLoadMorePending = () => {
    if (hasMorePending) {
      setPage((prev) => ({
        ...prev,
        pending: prev.pending + 1,
      }));
    }
  };

  const handleLoadMoreCompleted = () => {
    if (hasMoreCompleted) {
      setPage((prev) => ({
        ...prev,
        completed: prev.completed + 1,
      }));
    }
  };

  const statusCounts = {
    Pending: penddingres?.pagination?.totalRfqs || 0,
    Active: activeres?.pagination?.totalRfqs || 0,
    Completed: completedres?.pagination?.totalRfqs || 0,
    Draft: draftres?.pagination?.totalRfqs || 0,
  };

  // function openModalAndUpdateUrl(setViewStateFn, rfqId, key = "products", navigate) {
  //   // 1. Open the modal
  //   setViewStateFn({
  //     show: true,
  //     [key]: rfqId,
  //   });

  //   // 2. Use React Router navigation instead of pushState
  //   const currentPath = window.location.pathname;
  //   if (!currentPath.endsWith(`/${rfqId}`)) {
  //     navigate(`${currentPath}/${rfqId}`);
  //   }
  // }

  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.rfq_id}`;
    window.history.pushState(null, "", newUrl);
  };

  return (
    <>
      {/* {isCopyQuoteOpen.show && (
        <CopyEmailDialog
          module_id={isCopyQuoteOpen.rfq_id}
          show={isCopyQuoteOpen.show}
          onCopy={handleCopy_Quote}
          setShow={setIsCopyQuoteOpen}
        />
      )} */}

      {isEmailHistoryOpen.show && (
        <EmailHistory
          show={isEmailHistoryOpen.show}
          rfq_id={isEmailHistoryOpen.rfq_id}
          setShow={setIsEmailHistoryOpen}
        />
      )}

      {/* {isViewOpen.show && ( */}
      <View_ProjectDetails
        // show={isViewOpen.show}
        // opportunity={isViewOpen.products}
        // setShow={setIsViewOpen}
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
        triggerCardHighlight={triggerCardHighlight}
      />
      {/* )} */}

      {isEmailQuoteOpen.show && (
        <EmailProjectDialog
          username={user.username}
          show={isEmailQuoteOpen.show}
          rfq_id={isEmailQuoteOpen.rfq_id}
          Quote_No={isEmailQuoteOpen.Quote_No}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {/* {isEmaillOpen.show && (
                <KOorCustomerEmailDialog
                    pagetitle={isEmaillOpen.title}
                    toEmail={isEmaillOpen.toEmail}
                    toName={isEmaillOpen.toName}
                    RFQID={isEmaillOpen.RFQID}
                    show={isEmaillOpen.show}
                    skuData={isEmaillOpen.skuData}
                    row={isEmaillOpen.row}
                    defaultSubject={isEmaillOpen.defaultSubject}
                    Quote_No={isEmaillOpen.Quote_No}
                    setShow={setIsEmaillOpen}
                    setIsSuccsessModalOpen={setIsSuccsessModalOpen}
                />
            )} */}

      {isModalOpen.show && (
        <SKU_Version_POPUP
          rfqSku={rfqSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}
      {/* 
            {isHistoryOpen.show && (
                <GetRFQHistoryPOP_UP
                    rfqSku={rfqSku}
                    show={isHistoryOpen.show}
                    setShow={setIsHistoryOpen}
                />
            )} */}

      {isPriceOpen.show && (
        <PriceChangesModal
          show={isPriceOpen?.show}
          setShow={setIsPriceOpen}
          rfqid={isPriceOpen?.data}
          triggerCardHighlight={triggerCardHighlight}
        // onSuccessFetch={fetchData}
        />
      )}

      {isExcelOpen.show && (
        <ExcelDialog
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}

      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />

      {isListView ? null : (
        <>
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Contract Vehicles</h2>
              </div>
            </div>
          </div>

          <Card className="mb-3">
            <Card.Body>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <Row>
                  <Col md={2} className="mb-2">
                    <Form.Label className="form-label">Search</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconSearch />
                      </InputGroup.Text>
                      <Form.Control
                        ref={searchInputRef}
                        type="email"
                        placeholder="Search..."
                        required
                        name="name"
                        autoComplete="off"
                        value={search}
                        // onChange={handleSearch}
                        onChange={(e) => setSearch(e.target.value)} // Update search state on input change
                      />
                    </InputGroup>
                  </Col>

                  <Col md={2} className="mb-2">
                    <Form.Label className="form-label">
                      Sales Lead Email
                    </Form.Label>
                    <Form.Select
                      className="form-control"
                      value={salesHeadFilter}
                      onChange={handlesalesHeadFilter}
                    >
                      <option value={""}>All</option>
                      {SalesHead?.data?.map((sales) => (
                        <option key={sales?.id} value={sales?.email}>
                          {sales?.email}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={2} className="mb-2">
                    <label className="form-label">Select Status</label>
                    <MultiSelect
                      value={selectedStatus}
                      options={statusOptions}
                      onChange={(e) => {
                        setSelectedStatus(e.value);
                      }}
                      optionLabel="label"
                      placeholder="All"
                      display="chip"
                      className="w-100"
                      panelHeaderTemplate={() => null}
                    />
                  </Col>
                  {/* <Col md={2} className="mb-2">
                <Form.Label className="form-label">Contract Vehicle</Form.Label>
                <Form.Select
                  className="form-control"
                  value={contractFilter}
                  onChange={handleContractFilter}
                >
                  <option selected value={""}>
                    All
                  </option>
                  {contractData?.data?.map((vehicle, index) => (
                    <option key={index} value={vehicle.id}>
                      {vehicle.name}
                    </option>
                  ))}
                </Form.Select>
              </Col> */}

                  <Col md={4} className="mb-2">
                    <div className="d-flex gap-2">
                      <div className="w-100">
                        <Form.Label className="form-label">
                          Created Date From
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCalendarWeek />
                          </InputGroup.Text>
                          <DatePicker
                            className="form-control"
                            selected={startDate}
                            placeholderText="Select Date"
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            showMonthDropdown
                            showYearDropdown
                          // minDate={new Date()}
                          />
                        </InputGroup>
                      </div>

                      <div className="w-100">
                        <Form.Label className="form-label">
                          Created Date To
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCalendarWeek />
                          </InputGroup.Text>
                          <DatePicker
                            className="form-control"
                            selected={endDate}
                            placeholderText="Select Date"
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            showMonthDropdown
                            showYearDropdown
                          />
                        </InputGroup>
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className="mb-2 mt-2">
                    {/* <Form.Label className="form-label">&nbsp;</Form.Label> */}
                    <div className="d-flex gap-1">
                      <Button
                        style={{ minWidth: "auto" }}
                        variant="warning"
                        onClick={handleSearch}
                      >
                        {/* <IconSearch width={20} height={20} /> */}
                        Apply Filters
                      </Button>
                      <Button
                        style={{ minWidth: "auto" }}
                        variant="outline-secondary"
                        onClick={handleClearFilter}
                      >
                        Clear Filters
                      </Button>
                      {/* <Button
                        style={{ minWidth: "auto" }}
                        onClick={() => setIsExcelOpen({ show: true })}
                        variant="outline-success"
                      >
                        <IconFileTypeXls /> Download
                      </Button> */}
                    </div>
                  </Col>
                  <Form.Text>
                    Search by Project ID, contracting officer information,
                    description or any other relevant keyword.
                  </Form.Text>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </>
      )}

      {isListView ? null : (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      )}

      {isListView ? (
        <ProjectTableListing />
      ) : (
        <>
          <div className="scroll_status">
            <div
              className={`status_row_sticky d-none d-md-block  ${isFixed ? "is-fixed" : ""
                }`}
              ref={stickyRef}
            >
              {(isInitialLoad || activeStatuses.includes("DRAFT")) && (
                <div className="status_item_box draft_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#818183ff" />
                    <span className="fw-bold">Draft</span>
                  </div>
                  <span className="status_count" style={{ color: "#818183ff" }}>
                    {draftres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("PENDING")) && (
                <div className="status_item_box pending_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#F59F00" />
                    <span className="fw-bold">Pending</span>
                  </div>
                  <span className="status_count" style={{ color: "#F59F00" }}>
                    {penddingres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("ACTIVE")) && (
                <div className="status_item_box won_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#198754" />
                    <span className="fw-bold">Active</span>
                  </div>
                  <span className="status_count" style={{ color: "#198754" }}>
                    {activeres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("COMPLETED")) && (
                <div className="status_item_box won_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#198754" />
                    <span className="fw-bold">Completed</span>
                  </div>
                  <span className="status_count" style={{ color: "#198754" }}>
                    {completedres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}
            </div>

            <div
              className="stepper_status bs-stepper-header d-flex d-md-none"
              role="tablist"
            >
              {StatusList.map((step, idx) => (
                <div
                  className={`step ${currentStep === idx + 1
                    ? " active"
                    : idx + 1 < currentStep
                      ? "completed"
                      : ""
                    }`}
                  key={idx}
                >
                  <button
                    onClick={() => handleTabClick(idx + 1)}
                    type="button"
                    className="step-trigger"
                    role="tab"
                  >
                    <span className="bs-stepper-label d-flex align-items-center justify-content-between">
                      {step}
                      <span className="status_count ms-2">
                        {statusCounts[step] ?? 0}
                      </span>
                    </span>
                  </button>
                </div>
              ))}
            </div>

            <div className="status_row_box">
              {(isInitialLoad || activeStatuses.includes("DRAFT")) && (
                <div
                  className={`status_row_scroll ${currentStep === 5 ? "active_status_tab" : ""
                    }  Draft`}
                >
                  <>
                    {draftData?.length > 0 ? (
                      draftData?.map((row, index) => (
                        <Card
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                            ? "card-highlight "
                            : ""
                            }`}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Name:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#818183ff" }}
                                  >
                                    {row.ContractType?.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Number
                                </div>
                                <p className="label_card">{row?.rfq_id}</p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Start Date</div>
                                <p className="label_card">
                                  {moment(row?.start_date).format("MM/DD/YYYY")}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">End Date</div>
                                <p className="label_card">
                                  {row?.due_date === null
                                    ? "N/A"
                                    : moment(row?.due_date).format(
                                      "MM/DD/YYYY",
                                    )}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={() =>
                                  //   openModalAndUpdateUrl(setIsViewOpen, row.rfq_id,navigate)
                                  // }
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>

                              {/* 
                            {
                              opportunity?.RfqProducts.length != 0 && (
                                <button
                                  type="button"
                                  className="btn btn-warning mb-2"
                                  onClick={() => setIsPriceOpen({ show: true, data: null })}
                                >
                                  Price Change
                                </button>
                              )
                            } */}


                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsPriceOpen({
                                      show: true,
                                      data: row?.rfq_id,
                                    });
                                  }}
                                >
                                  <IconExchange size={24} />
                                </span>
                                <b> Price Changes</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/list-contract-vehicles-price-changes/${row.rfq_id}`);

                                  }}
                                >

                                  <IconExchange size={24} />
                                </span>
                                <b> Kit Price Changes</b>
                              </div>




                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  HandlePDFClick(row);
                                }}
                              >
                                <IconFileTypePdf size={24} />{" "}
                              </span>
                              <b> Generate PDF</b>
                            </div> */}
                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email History</b>
                            </div> */}
                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailQuoteOpen({
                                    show: true,
                                    Quote_No: row?.invoice_no,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailForward size={24} />{" "}
                              </span>
                              <b>Send Mail</b>
                            </div> */}
                            </div>
                            <div className="rfq_card_row mt-3 justify-content-center">
                              {row?.project_budget !== null && (
                                <div className="total_amt_rfq">
                                  <strong>Total Budget:</strong>
                                  <strong className="amt_bold">
                                    ${row?.project_budget}
                                  </strong>
                                </div>
                              )}
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/edit-contract-vehicle/${row?.rfq_id}`,
                                  );
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {draftres?.data?.length >= 10 && hasMoreDraft && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMoreDraft}
                        disabled={loadingDraft}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingDraft ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("PENDING")) && (
                <div
                  className={`status_row_scroll ${currentStep === 1 ? "active_status_tab" : ""
                    }  Pending`}
                >
                  <>
                    {pendingData?.length > 0 ? (
                      pendingData?.map((row, index) => (
                        <Card
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                            ? "card-highlight "
                            : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Name:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#F59F00" }}
                                  >
                                    {row.ContractType?.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Number
                                </div>
                                <p className="label_card">{row?.rfq_id}</p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Start Date</div>
                                <p className="label_card">
                                  {moment(row?.start_date).format("MM/DD/YYYY")}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">End Date</div>
                                <p className="label_card">
                                  {row?.due_date === null
                                    ? "N/A"
                                    : moment(row?.due_date).format(
                                      "MM/DD/YYYY",
                                    )}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsPriceOpen({
                                      show: true,
                                      data: row?.rfq_id,
                                    });
                                  }}
                                >
                                  <IconExchange size={24} />
                                </span>
                                <b> Price Changes</b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/list-contract-vehicles-price-changes/${row.rfq_id}`);

                                  }}
                                >

                                  <IconExchange size={24} />
                                </span>
                                <b> Kit Price Changes</b>
                              </div>


                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  HandlePDFClick(row);
                                }}
                              >
                                <IconFileTypePdf size={24} />{" "}
                              </span>
                              <b> Generate PDF</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email History</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailQuoteOpen({
                                    show: true,
                                    Quote_No: row?.invoice_no,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailForward size={24} />{" "}
                              </span>
                              <b>Send Mail</b>
                            </div> */}
                            </div>
                            <div className="rfq_card_row mt-3 justify-content-center">
                              {row?.project_budget !== null && (
                                <div className="total_amt_rfq">
                                  <strong>Total Budget:</strong>
                                  <strong className="amt_bold">
                                    ${row?.project_budget}
                                  </strong>
                                </div>
                              )}
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/edit-contract-vehicle/${row?.rfq_id}`,
                                  );
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>
                  {penddingres?.data?.length >= 10 && hasMorePending && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMorePending}
                        disabled={loadingPending}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingPending ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("ACTIVE")) && (
                <div
                  className={`status_row_scroll ${currentStep === 2 ? "active_status_tab" : ""
                    }  active`}
                >
                  <>
                    {activeData?.length > 0 ? (
                      activeData?.map((row, index) => (
                        <Card
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                            ? "card-highlight "
                            : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Name:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#198754" }}
                                  >
                                    {row.ContractType?.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Number
                                </div>
                                <p className="label_card">{row?.rfq_id}</p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Start Date</div>
                                <p className="label_card">
                                  {moment(row?.start_date).format("MM/DD/YYYY")}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">End Date</div>
                                <p className="label_card">
                                  {row?.due_date === null
                                    ? "N/A"
                                    : moment(row?.due_date).format(
                                      "MM/DD/YYYY",
                                    )}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsPriceOpen({
                                      show: true,
                                      data: row?.rfq_id,
                                    });
                                  }}
                                >
                                  <IconExchange size={24} />
                                </span>
                                <b> Price Changes</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/list-contract-vehicles-price-changes/${row.rfq_id}`);

                                  }}
                                >

                                  <IconExchange size={24} />
                                </span>
                                <b> Kit Price Changes</b>
                              </div>


                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  HandlePDFClick(row);
                                }}
                              >
                                <IconFileTypePdf size={24} />{" "}
                              </span>
                              <b> Generate PDF</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email History</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailQuoteOpen({
                                    show: true,
                                    Quote_No: row?.invoice_no,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailForward size={24} />{" "}
                              </span>
                              <b>Send Mail</b>
                            </div> */}
                            </div>
                            <div className="rfq_card_row mt-3 justify-content-center">
                              {row?.project_budget !== null && (
                                <div className="total_amt_rfq">
                                  <strong>Total Budget:</strong>
                                  <strong className="amt_bold">
                                    ${row?.project_budget}
                                  </strong>
                                </div>
                              )}
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/edit-contract-vehicle/${row?.rfq_id}`,
                                  );
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>
                  {activeres?.data?.length >= 10 && hasMoreActive && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMore}
                        disabled={loadingActive}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingActive ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("COMPLETED")) && (
                <div
                  className={`status_row_scroll ${currentStep === 3 ? "active_status_tab" : ""
                    }  Completed`}
                >
                  <>
                    {completedData?.length > 0 ? (
                      completedData?.map((row, index) => (
                        <Card
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                            ? "card-highlight "
                            : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Name:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#198754" }}
                                  >
                                    {row.ContractType?.name}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Number
                                </div>
                                <p className="label_card">{row?.rfq_id}</p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Start Date</div>
                                <p className="label_card">
                                  {moment(row?.start_date).format("MM/DD/YYYY")}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">End Date</div>
                                <p className="label_card">
                                  {row?.due_date === null
                                    ? "N/A"
                                    : moment(row?.due_date).format(
                                      "MM/DD/YYYY",
                                    )}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsPriceOpen({
                                      show: true,
                                      data: row?.rfq_id,
                                    });
                                  }}
                                >
                                  <IconExchange size={24} />
                                </span>
                                <b> Price Changes</b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/list-contract-vehicles-price-changes/${row.rfq_id}`);

                                  }}
                                >

                                  <IconExchange size={24} />
                                </span>
                                <b> Kit Price Changes</b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  HandlePDFClick(row);
                                }}
                              >
                                <IconFileTypePdf size={24} />{" "}
                              </span>
                              <b> Generate PDF</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailHistoryOpen({
                                    show: true,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailSpark size={24} />
                              </span>
                              <b>Email History</b>
                            </div>
                            <div className="badge_btn">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsEmailQuoteOpen({
                                    show: true,
                                    Quote_No: row?.invoice_no,
                                    rfq_id: row.rfq_id,
                                  });
                                }}
                              >
                                <IconMailForward size={24} />{" "}
                              </span>
                              <b>Send Mail</b>
                            </div> */}
                            </div>
                            <div className="rfq_card_row mt-3 justify-content-center">
                              {row?.project_budget !== null && (
                                <div className="total_amt_rfq">
                                  <strong>Total Budget:</strong>
                                  <strong className="amt_bold">
                                    ${row?.project_budget}
                                  </strong>
                                </div>
                              )}
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/edit-contract-vehicle/${row?.rfq_id}`,
                                  );
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {completedres?.data?.length >= 10 && hasMoreCompleted && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMoreCompleted}
                        disabled={loadingCompleted}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingCompleted ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProjectListing;
